/**
 * TargetedMessagingProvider.ts
 *
 * Module for targeted messaging campaign definition provider.
 */
import { FilterValidCampaignDefinitions } from "@ms-ofb/officefloodgatecore/dist/src/Campaign/CampaignDefinitionProvider";
import { getDynamicSetting } from "../Configuration/DynamicConfiguration";
import { TMS_CAMPAIGN_LOAD_TIMEOUT } from "./TargetedMessagingConstants";
import { createTimeoutPromise } from "../Utils";
import * as AssetsProvider from "./AssetsProvider";
export class TargetedMessagingCampaignDefinitionProvider {
  constructor() {
    this.loadAsyncTriggered = false;
    this.campaignDefinitions = [];
  }
  load() {
    if (!this.loadAsyncTriggered) {
      this.loadAsync();
      this.loadAsyncTriggered = true;
    }
    return this.campaignDefinitions || [];
  }
  loadAsync() {
    const thisObj = this;
    const campaignDefinitionsPromise = AssetsProvider.get().getCampaignDefinitions();
    campaignDefinitionsPromise.then(response => {
      thisObj.loadCampaignDefinitions(response);
      thisObj.loadAsyncTriggered = true;
    });
    const timeoutMilliseconds = getDynamicSetting("TmsLoadTimeout" /* tmsLoadTimeout */, TMS_CAMPAIGN_LOAD_TIMEOUT);
    const timeoutPromise = createTimeoutPromise(timeoutMilliseconds, campaignDefinitionsPromise);
    return new Promise((resolve, reject) => {
      timeoutPromise.then(function onFulfilled(response) {
        thisObj.loadCampaignDefinitions(response);
        thisObj.loadAsyncTriggered = true;
        resolve(thisObj.campaignDefinitions);
      }).catch(
      // might have timed out or getCampaignDefinitions might have failed
      // In either case we resolve with cached content
      function onRejected(error) {
        if (thisObj.campaignDefinitions.length <= 0) {
          thisObj.loadCampaignDefinitions(AssetsProvider.get().getCachedCampaignDefinitions());
        }
        resolve(thisObj.campaignDefinitions);
      }).catch(
      // handle any errors from catch block
      function onRejected(error) {
        resolve(thisObj.campaignDefinitions);
      });
    });
  }
  loadCampaignDefinitions(response) {
    const definitions = response && response.campaigns;
    if (definitions) {
      this.campaignDefinitions = FilterValidCampaignDefinitions(definitions).result;
    }
  }
}